<template>
  <div class="header-section">
    <template v-if="isMobile">
      <!-- 移动端头部 -->
      <div class="mobile-header">
        <div class="mobile-logo">
          <img src="/assets/images/header/logo-dark.png" alt="METTA" />
        </div>
        <div class="mobile-menu-btn" @click="openMenu">
          <i></i><i></i><i></i>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- pc端头部 -->
      <!-- <nav class="head-component" :class="{ 'scrolled': isScrolled }"> -->
      <nav class="head-component scrolled">
        <div class="nav-logo">
          <router-link to="/">
            <img src="/assets/images/home/logo.svg" alt="METTA" />
          </router-link>
        </div>
        <div class="nav-links">
          <router-link v-for="(item, index) in menuList" :key="index" :to="item.path">{{ item.name }}</router-link>
          <!-- <router-link to="/metta-world">麦塔之境</router-link>
          <router-link to="/badain-jaran">巴丹吉林</router-link>
          <router-link to="/n35-loki">N35° 洛基</router-link>
          <router-link to="/ultra">Ultra</router-link>
          <router-link to="/metta-community">社区</router-link>
          <router-link to="/metta-channel">渠道</router-link>
          <router-link to="/metta-store">商城</router-link>
          <router-link to="/garage">载具库</router-link>
          <router-link to="/events">赛事</router-link> -->
        </div>
        <div class="nav-btns">
          <button class="btn-ghost" @click="openLoginModal">登录</button>
        </div>
      </nav>
    </template>
    <div v-show="mobileMenuShow" class="mobile-menu-modal">
      <div class="mobile-menu-close" @click="closeMenu"></div>
      <div class="mobile-menu-list">
        <router-link v-for="(item, index) in menuList" :key="index" :to="item.path" @click.native="closeMenu">{{ item.name }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { checkIsMobile } from '../utils/tools.js'
export default {
  name: "HeadComponent",
  data() {
    return {
      isMobile: false,
      mobileMenuShow: false,
      isScrolled: false,
      menuList: [
        { name: 'METTA之境', path: '/metta-world' },
        { name: '巴丹吉林', path: '/badain-jaran' },
        { name: 'N30° 洛基', path: '/n30-loki' },
        { name: 'N30° 雅丹', path: '/n30-three-doors' },
        { name: 'N30° 环球穿越', path: '/n30-cross' },
        { name: 'E-BIKE', path: '/classic-ebike' },
        { name: 'ULTRA', path: '/ultra' },
        { name: 'T1+', path: '/ultra-t1' },
        { name: 'UTV', path: '/ultra-utv' },
        // { name: '渠道', path: '/metta-channel' },
        //{ name: '社区', path: '/metta-community' },
        { name: '社区', path: '/community2' },
        //{ name: '商城', path: '/metta-store' },
        //{ name: '载具库', path: '/garage' },
        // { name: '赛事', path: '/events' },
        { name: '关于', path: '/about' },
      ]
    }
  },
  mounted() {
    this.checkDevice();
    this.handleScroll();
    window.addEventListener('resize', this.checkDevice);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
    handleScroll() {
      // 滚动超过一屏之后加上半透明效果
      this.isScrolled = window.scrollY > window.innerHeight;
    },
    openMenu() {
      this.mobileMenuShow = true;
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    },
    closeMenu() {
      this.mobileMenuShow = false;
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    },
    openLoginModal() {
      window.open(

        'https://community-metta.sixeco.com/',

        '_blank'

      )
    }
  }
}
</script>

<style lang="less" scoped>
.header-section {
  font-family: 'TsangerYunHei', sans-serif;
  font-weight: @fw2;
}
.head-component {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 2.7vw;
  background: transparent; 
  backdrop-filter: blur(0px);
  -webkit-backdrop-filter: blur(0px);
  border-bottom: 1px solid transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.04vw;
  z-index: 900;
  transition: background 0.3s ease, backdrop-filter 0.3s ease, border-bottom 0.3s ease;
  &.scrolled {
    background: rgba(247, 247, 245, 0.7);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
  /* ─── NAV LOGO ─── */
  .nav-logo {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    img {
      height: 0.93vw;
      width: auto;
      display: block;
    }
  }

  /* ─── NAV LINKS ─── */
  .nav-links {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    list-style: none;
    column-gap: 1.6vw;
    a {
      font-size: clamp(12px, 0.83vw, 16px);
      letter-spacing: 1.5px;
      text-transform: uppercase;
      color: #000000;
      text-decoration: none;
      padding: 6px 10px 5px;
      font-weight: @fw2;
      transition: color 0.15s;
      white-space: nowrap;
      border-bottom: 1px solid transparent;

      &.nav-active {
        color: #080808;
        border-bottom: 1px solid #080808;
      }

      &:hover {
        color: #080808;
      }
    }
  }

  /* ─── NAV BUTTONS ─── */
  .nav-btns {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .btn-ghost {
    font-size: clamp(12px,0.83vw,16px);
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #000;
    border: 1px solid #000;
    padding: 6px 10px 5px;
    background: none;
    font-family: inherit;
    font-weight: @fw2;
    cursor: pointer;
    transition: all 0.15s;

    &:hover {
      color: #080808;
      border-color: #080808;
    }
  }

  .btn-solid {
    font-size: 9.5px;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #f7f7f5;
    background: #080808;
    border: 1px solid #080808;
    padding: 7px 16px;
    font-family: inherit;
    font-weight: @fw2;
    cursor: pointer;
  }
}
.mobile-header {
  height: 9.33vw;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  padding: 0 4.8vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(247, 247, 245, 0.7);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  .mobile-logo {
    img {
      height: 4.27vw;
      width: auto;
    }
  }
  .mobile-menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 1.07vw;
    i {
      width: 6.4vw;
      height: 1px;
      border-radius: 1px;
      background: #070404;
    }

  }
}
.mobile-menu-modal {
  position: fixed;
  inset: 0;
  z-index: 100;
  background-color: #fff;
  .mobile-menu-close {
    height: 10.67vw;
    width: 10.67vw;
    position: absolute;
    right: 0;
    top: 0;
    background-image: url('/assets/images/header/icon-close.png');
    background-size: 6.4vw;
    background-repeat: no-repeat;
    background-position: center;
  }
  .mobile-menu-list {
    margin-top: 10.67vw;
    display: flex;
    flex-direction: column;
    font-weight: @fw2;
    font-size: 5.33vw;
    color: #242222;
    text-align: center;
    letter-spacing: 0.4vw;
    // gap: 3.2vw;
    a {
      height: 14.66vw;
      line-height: 14.66vw;
      &.nav-active {
        background-color: rgba(188, 188, 188, 0.2);
      }
    }
  }
}
</style>